module.exports = __webpack_public_path__ + "static/media/14n.4206ca19.svg";